import script from "./IndustrySwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./IndustrySwitcher.vue?vue&type=script&setup=true&lang=js"

import "./IndustrySwitcher.vue?vue&type=style&index=0&id=6e579a7b&scoped=true&lang=css"

import exportComponent from "/Users/yousefgadban/Developer/applates/applatesLandingVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e579a7b"]])

export default __exports__